module.exports = __webpack_public_path__ + "img/bubble-screen.e615a1fd.png";